<template>
  <nav class="navbar navbar-inverse navbar-fixed-top" style="background:#ffffff ">
    <div class="container" style="padding: 0">
      <router-link to="/service">
        <h1 class="navbar-brand navbar-left"
            style="color:rgb(29, 142, 242);font-size:20px;font-weight:600;padding: 15px 5px 0 5px;margin: 0">
          &nbsp;&nbsp;&nbsp;&nbsp;{{appName}}PDA
        </h1></router-link>
      <div class="navbar-brand navbar-right" style="float:right;padding: 5px">

        <div style="padding: 10px;background: rgb(29,142,242);border-radius: 10%;border:none"
             v-if="!$store.state.user.token">
          <a style="color: #FFFFFF;font-size: 15px"
             @click="showModal">
            登录
          </a>
        </div>
        <el-popover v-if="$store.state.user.token"
                    placement="bottom-end"
                    width="20"
                    trigger="click">
          <el-menu default-active="1"
                   class="el-menu-vertical-demo">
            <el-menu-item index="2">
              <i class="el-icon-user-solid"></i>
              <span slot="title">{{ $store.state.user.username }}</span>
            </el-menu-item>
            <el-menu-item index="3"
                          @click="remove">
              <i class="el-icon-s-unfold"></i>
              <span slot="title">退出</span>
            </el-menu-item>
          </el-menu>
          <el-avatar slot="reference" style="background: #ffffff"
                     :src="$store.state.user.headimgurl ||this.header">
          </el-avatar>
        </el-popover>
      </div>
      <a-modal v-model="visible"
               :footer="null">
        <div v-show="scan">
          <!--            <h2>扫码登录</h2>-->
          <span class="flex">已有帐号？<a @click="scan=false">密码登录</a></span>
          <div id="weixin"></div>
        </div>
        <div class="login"
             v-show="!scan">
          <div class="login_form">
            <div class="logo_header"
                 v-show="!second & !unlearn">
              <h2>登录</h2>
              <!--              <span class="flex">没有帐号？<a @click="account('second')">点此注册</a></span>-->
            </div>
            <el-form :model="loginForm"
                     v-show="!second & !unlearn"
                     :rules="rules"
                     ref="loginForm"
                     @submit.native.prevent>
              <el-form-item label=""
                            prop="mobile"
                            class="elItem">
                <el-input type="text"
                          autocomplete="off"
                          v-model="loginForm.mobile"
                          prefix-icon="el-icon-user-solid"
                          placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label=""
                            prop="password">
                <el-input type="password"
                          autocomplete="off"
                          v-model="loginForm.password"
                          prefix-icon="el-icon-lock"
                          placeholder="请输入密码"></el-input>
              </el-form-item>
              <!--                <p class="scan">-->
              <!--                  <a @click="scan=true">扫码登录</a>-->
              <!--                </p>-->
              <el-form-item class="btns">
                <el-button type="primary"
                           @click="goToLogin"
                           :loading="loading"
                           native-type="submit">登录
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </a-modal>
    </div>
  </nav>
</template>

<script>
// import storage from "store"
// import { ACCESS_TOKEN } from "../services/mutation-types"
import {mapState} from "vuex";
import {getToken} from "@/api/common";
import {getLogin} from "@/api/login";
import register from "@/components/register";
import forget from "@/components/forget";
import head from "@/assets/images/header1.png";
import {getConfigApi} from "../api/login";
import {getCodeLengthApi} from "../api/data_bind";

export default {
  name: "home",
  components: {
    register,
    forget,
  },
  created() {
    this.getConfig()
    this.getCodeLength()
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码需要超过6位!"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("账号不能为空，请输入邮箱"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value) && !/.*?@.*?com$/.test(value)) {
        callback(new Error("账号不正确，请输入邮箱"));
      }
      //自定义校验规则 需要调用callback()函数！
      callback();
    };
    return {
      appName:'',
      is_agent: false,
      host: "",
      width: 0,
      visible: false,
      show: false,
      second: false, //注册
      unlearn: false, //忘记密码
      scan: false,
      loading: false,
      appSecret: "oeuednafwe52edadafdcasdwed",
      loginForm: {
        mobile: "",
        password: "",
      },
      header: head,
      rules: {
        mobile: [{required: true, message: "请输入用户名", trigger: "change"}],
        password: [{required: true, message: "请输入密码", trigger: "change"}],
      },
    };
  },
  mounted() {
  },
  computed: {},
  methods: {
    account(name) {
      switch (name) {
        case "second":
          this.second = true;
          this.unlearn = false;
          this.$refs.register.resetNickname();
          break;
        case "unlearn":
          this.second = false;
          this.unlearn = true;
          this.$refs.forget.resetNickname();
          break;
        default:
          this.second = false;
          this.unlearn = false;
          this.resetNickname();
          break;
      }
    },
    goToLogin() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = {
            username: this.loginForm.mobile,
            password: this.loginForm.password
          };
          getLogin(params).then((res) => {
            if (res.code == 200) {
              this.$message.success('登录成功');
              const user = {
                token: res.token,
                username: params.username
              }
              this.$store.commit("setUser", user);
              this.visible = false;
              this.loading = false;
            } else {
              this.$message.error(res.msg);
              this.loading = false;
            }
          });
        } else {
          //   this.$message.error("登陆失败");
          return false;
        }
      });
    },
    showModal() {
      this.visible = true;
    },
    showLogin() {
      if (!this.$store.state.user) {
        this.showModal()
      }
    },
    remove() {
      this.$message.success("退出登录");
      this.$store.commit("setUser", "");
      setTimeout(() => {
        this.$router.push("/");
        this.show = false;
      }, 200);
    },
    getConfig() {
      getConfigApi().then((res) => {
        if (res.code == 200) {
          this.appName = res.data.sys_app_name
          this.$store.commit("setBusiness", res.data.business_name)
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    getCodeLength() {
      getCodeLengthApi().then((res) => {
        if (res.code == 200) {
          this.$store.commit("setCodeLen", res.data)
        } else {
          this.$message.error(res.msg)
        }
      });
    }
  },
};
</script>
<style scoped>
#weixin {
  width: 400px;
  height: 400px;
  margin: 40px auto;
  text-align: center;
}

.ant-avatar {
  cursor: pointer;
}

.navbar-fixed-top {
  z-index: 10;
}

.navbar-form {
  margin-bottom: 0;
}

a {
  display: block;
}

.el-popover {
  padding: 0 !important;
}

.flex {
  display: flex;
}

h2 {
  margin: 0;
}

.login_form {
  padding-top: 30px;
}

.logo_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.el-form {
  margin-top: 30px;
}

.el-button--primary {
  width: 100%;
}

.text-center {
  text-align: center;
}

.scan {
  text-align: right;
}

.navbar {
  color: #FFFFFF;
  border-color: #FFFFFF;

}

.btn-primary-outline {
  color: #FFFFFF;
  border-color: #FFFFFF;
}

.el-avatar {
  line-height: 20px;
}

.font1 {
  font-size: 100%;
}

.font2 {
  font-size: 20px;
}
</style>


